export const purposeSelectorOptions = {
  residencial: 'residencial',
  comercial: 'comercial',
}

export const propertyTypesLandingMap = {
  Residentail: [
    'Casa',
    'Cochera',
    'Departamento',
    'Depósito',
    'PH',
    'Terreno',
  ],
  Offices: [
    'Edificio Comercial',
    'Oficina',
    'Terreno',
  ],
  Retail: [
    'Local',
    'Terreno',
  ],
  Industries: [
    'Depósito',
    'Galpón',
    'Terreno',
  ],
  Emprendimientos: [
    'Departamento',
    'Terreno',
  ],
  Lands: [
    'Terreno',
  ]
}



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/PurposeSelector/PurposeSelector.constants.js